import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from '@studio-freight/lenis';
import { Toaster } from "./components/ui/toaster";

// Components
import { Navigation } from "./components/Navigation";
import { HeroSection } from "./components/HeroSection";
import { AboutSection } from "./components/AboutSection";
import { ServicesSection } from "./components/ServicesSection";
import { ValuePropsSection } from "./components/ValuePropsSection";
import { TechStackSection } from "./components/TechStackSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";

// Pages
import { ConsultationPage } from "./pages/ConsultationPage";
import { InstantQuotePage } from "./pages/InstantQuotePage";
import { MaintenancePage } from "./pages/MaintenancePage";

const HomePage = () => {
  return (
    <div data-testid="home-page">
      <Navigation />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ValuePropsSection />
        <TechStackSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    // Initialize Lenis smooth scroll
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // Handle hash navigation for smooth scroll
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          setTimeout(() => {
            lenis.scrollTo(element, { offset: -80 });
          }, 100);
        }
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    
    // Initial check for hash
    if (window.location.hash) {
      handleHashChange();
    }

    return () => {
      lenis.destroy();
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <div className="App">
      {/* Subtle grain texture overlay */}
      <div className="grain-overlay" />
      
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/consultation" element={<ConsultationPage />} />
          <Route path="/instant-quote" element={<InstantQuotePage />} />
          <Route path="/maintenance" element={<MaintenancePage />} />
        </Routes>
      </BrowserRouter>
      
      <Toaster />
    </div>
  );
}

export default App;
